/* eslint-disable @typescript-eslint/no-explicit-any */
// Copyright 2016 Sorama B.V.

import { IValueConverter } from "aurelia-binding-ext";
import { NotSupportedError } from "errors/NotSupportedError";

export class ObjectKeysValueConverter implements IValueConverter<unknown, unknown[]> {
    public toView(value: any): unknown[] {
        const temp: unknown[] = [];

        for (const prop in value) {
            temp.push(prop);
        }

        return temp;
    }

    public fromView(value: boolean, param?: boolean): unknown[] {
        throw new NotSupportedError("Conversion from keys to object in ObjectKeysValueConverter is not supported.");
    }
}
